<app-loader [Parent]="this"></app-loader>
@if (Model) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
    </app-pageheader>
    <div class="columns is-multiline">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Printer Details
          </p>
          <a class="panel-block">
            <span class="label">Name</span>
            <span class="value">{{Model.Name}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Mac Address</span>
            <span class="value">{{Model.MacAddress}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Printer Type</span>
            <span class="value">{{Model.PrinterType}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Paper Size</span>
            <span class="value">{{Model.PrinterPaperSize}}</span>
          </a>
        </article>
      </div>
    </div>
  </div>
}